/** Ранг грейда на общей оси 0–100 (для сравнения разных шкал) или undefined, если неизвестен. */
export function gradeRank(meta, grade) {
    return meta.gradeScales
        .find((s) => s.code === grade.scale)
        ?.values.find((v) => v.code === grade.value)?.rank;
}
/** Отрицательное — a хуже b, 0 — одинаково, положительное — a лучше. */
export function compareGrades(meta, a, b) {
    return (gradeRank(meta, a) ?? -1) - (gradeRank(meta, b) ?? -1);
}
//# sourceMappingURL=grade.js.map